module.exports = "<!--\n   \n   Copyright (c) 2017, the Perspective Authors.\n   \n   This file is part of the Perspective library, distributed under the terms of\n   the Apache License 2.0.  The full license can be found in the LICENSE file.\n\n-->\n\n<template id='perspective-hypergrid'>\n    <div id='gridWrapper'>\n        <div id='mainGrid'></div>\n    </div>\n</template>";


//////////////////
// WEBPACK FOOTER
// ./cjs/html/hypergrid.html
// module id = 241
// module chunks = 0